import React, { useEffect} from "react";
import { Table  } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { getUserList, doUserDelete } from "../../../../redux/user/userState";
import { handleTableChange } from "../../../../utils/index";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";

const UserTable = ({ recordList, pagination, doSearch, filters, doDelete, ...props }) => {
  	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
		{
	        title: `Username`,
	        dataIndex: 'name',
	        key: 'name',
	        width: '24%',
			sorter: true,
			...getColumnSearchProps('name'),
	        render:(name) => <span>{name}</span> 
	    },
	    {
	        title: `Email`,
	        dataIndex: 'email',
	        key: 'email',
	        width: '24%',
	        sorter: true,
	        ...getColumnSearchProps('email'),
	        render:(email) => <span>{email}</span>
	    },
		{
	        title: `Roles / Groups`,
	        dataIndex: 'user_roles_groups',
	        key: 'user_roles_groups',
	        width: '40%',
	        render:(user_roles_groups) => <span>{user_roles_groups}</span>
	    },
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/users/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'id',
	        key: 'id',
	        width: '12%',
	        render:(id) => <CrudOption baseRoute="/console/users" recordId={id} deleteHandler={doDelete}/>
	    },
    ];
    
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"} {...props}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		
	      		<SearchFilter searchHandler={doSearch} filters={filters} pagination={pagination}/>
	      		
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.id}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}               	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.user.userList?.items,
  	pagination: state.user.userList?.pagination,
	filters: state.user.userList?.filters,
  	requesting: state.user.userList?.requesting,
  	error: state.user.userList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getUserList(filters)),
  	doDelete: (id) => dispatch(doUserDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserTable);